<template>

       <div class="container">
                <div class="page-header">
                    <div class="page-title">
                     
                        <div class="crumbs">
                            <ul id="breadcrumbs" class="breadcrumb">
                                 <li>
                                  <router-link :title="'الرئيسيه'" :to="{name: 'dashboard'}"> <i class="flaticon-home-fill"></i> الرئيسيه</router-link>
                                </li>
                               <li class="active">
                                  <router-link :title="'رسوم الطلاب'" :to="{name: 'students.fees.index'}">رسوم الطلاب</router-link>
                                </li>
                                 <li class="active">
                                  <router-link :title="'تعديل'" :to="{name: 'students.fees.edit', params: {id: $route.params.id}}">تعديل</router-link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                
            <div class="row">

                    <div class="col-lg-12 col-lg-12 col-md-12 col-sm-12 col-12  layout-spacing">
                        <div class="statbox widget box box-shadow">
                            <div class="widget-header">                                
                                <div class="row">
                                    <div class="col-xl-12 col-md-12 col-sm-12 col-12">
                                        <h4>
                                                <i class="flaticon-computer-4"></i> 
                                            بيانات الرسوم </h4>
                                    </div>
                                </div>
                            </div>
                             <div class="widget-content widget-content-area">
                               <form @submit.prevent="update()">
                                <div class="row mt-4">

                                    <div class="col-md-4">
                                        <div class="form-group mb-4">
                                            <label for="exampleFormControlInput12">التاريخ</label>
                                            <date-picker v-model="data.form.created_date" :disabled="true" :calendar="'hijri'"></date-picker>
                                            <div class="invalid-feedback" :style="getErrors['created_date'] ? 'display: block' : 'display: none;'"  v-if="getErrors['created_date']">
                                                  {{ getErrors['created_date'][0] }}
                                            </div>
                                        </div>
                                      </div>
                                      

                                      <div class="col-md-4" v-if="data.form.is_fees == 0">
                                        <div class="form-group mb-4">
                                            <label for="exampleFormControlInput12">كود البرنامج</label>
                                            <treeselect :options="activities" :auto-load-root-options="true" @select="getHandleDataFrom" v-model="data.form.activity_id" :multiple="false"/>

                                            <div class="invalid-feedback" :style="getErrors['activity_id'] ? 'display: block' : 'display: none;'"  v-if="getErrors['activity_id']">
                                                  {{ getErrors['activity_id'][0] }}
                                            </div>
                                        </div>
                                      </div>

                                      <div class="col-md-4">
                                        <div class="form-group mb-4">
                                            <label for="exampleFormControlInput12">المرحلة الدراسية</label>
                                            <treeselect :options="stages" v-model="data.form.stages"  @input="getStageCount" :multiple="false" />

                                            <div class="invalid-feedback" :style="getErrors['stages'] ? 'display: block' : 'display: none;'"  v-if="getErrors['stages']">
                                                  {{ getErrors['stages'][0] }}
                                            </div>
                                        </div>
                                      </div>  


                                      
                                       <div class="col-md-4" v-if="data.form.is_fees == 1">
                                        <div class="form-group mb-4">
                                            <label for="exampleFormControlInput12">البند</label>
                                            <treeselect :options="items" :auto-load-root-options="true"  v-model="data.form.item_id" :multiple="false"/>
                                            <div class="invalid-feedback" :style="getErrors['item_id'] ? 'display: block' : 'display: none;'"  v-if="getErrors['item_id']">
                                                  {{ getErrors['item_id'][0] }}
                                            </div>
                                        </div>
                                      </div>

                                      
                                      <div class="col-md-12" v-if="data.form.is_fees == 1">
                                        <div class="form-group mb-4">
                                            <label for="exampleFormControlInput12">الطالب</label>
                                             <treeselect
                                                v-model="data.form.student_id"
                                                :options="students"
                                                :async="false"
                                                :multiple="false"
                                                placeholder="Open the menu..."
                                            />
                                            <div class="invalid-feedback" :style="getErrors['student_id'] ? 'display: block' : 'display: none;'"  v-if="getErrors['student_id']">
                                                  {{ getErrors['student_id'][0] }}
                                            </div>
                                        </div>
                                      </div>

                                       <div class="col-md-12" v-if="data.form.is_fees == 0">
                                     <label for="exampleFormControlInput12">وصف البرنامج</label>
                                  <div class="input-group mb-4">
                                      
                                      <div class="input-group-prepend">
                                        <span class="input-group-text" id="basic-addon1"><i class="flaticon-file"></i></span>
                                      </div>
                                            <input type="text" class="form-control" v-model="data.form.description" placeholder="وصف البرنامج">
                                            <div class="invalid-feedback" :style="getErrors['description'] ? 'display: block' : 'display: none;'"  v-if="getErrors['description']">
                                                  {{ getErrors['description'][0] }}
                                            </div>
                                        </div>
                                      </div>

                                       <div class="col-md-4" v-if="data.form.is_fees == 0">
                                       
<label for="exampleFormControlInput12">الفترة</label>                                 
 <div class="input-group mb-4">
                                      
                                      <div class="input-group-prepend">
                                        <span class="input-group-text" id="basic-addon1"><i class="flaticon-clock"></i></span>
                                      </div>
                                            <input type="text" class="form-control" v-model="data.form.period" placeholder="الفترة" required> 
                                            <div class="invalid-feedback" :style="getErrors['period'] ? 'display: block' : 'display: none;'"  v-if="getErrors['period']">
                                                  {{ getErrors['period'][0] }}
                                            </div>
                                        </div>
                                      </div>
                                     

                                      <div class="col-md-4" v-if="data.form.is_fees == 0">
                                        <label for="exampleFormControlInput12"> المكان</label>                               
 <div class="input-group mb-4">
                                      
                                      <div class="input-group-prepend">
                                        <span class="input-group-text" id="basic-addon1"><i class="flaticon-location"></i></span>
                                      </div>
                                            <input type="text" class="form-control" v-model="data.form.place" placeholder="المكان">
                                            <div class="invalid-feedback" :style="getErrors['place'] ? 'display: block' : 'display: none;'"  v-if="getErrors['place']">
                                                  {{ getErrors['place'][0] }}
                                            </div>
                                        </div> 
                                      </div>

                                      <div class="col-md-4">
                                        <label for="exampleFormControlInput12"> التكلفة الفعلية</label>
  <div class="input-group mb-4">
                                      
                                      <div class="input-group-prepend">
                                        <span class="input-group-text" id="basic-addon1"><i class="flaticon-money"></i></span>
                                      </div>
                                            <input type="text" class="form-control" v-model="data.form.total_cost" placeholder="التكلفة الفعلية">
                                            <div class="invalid-feedback" :style="getErrors['total_cost'] ? 'display: block' : 'display: none;'"  v-if="getErrors['total_cost']">
                                                  {{ getErrors['total_cost'][0] }}
                                            </div>
                                        </div>
                                      </div>

                                      <div class="col-md-4" v-if="data.form.is_fees == 0">
                                        <label for="exampleFormControlInput12"> المسئول</label>
  <div class="input-group mb-4">
                                      
                                      <div class="input-group-prepend">
                                        <span class="input-group-text" id="basic-addon1"><i class="flaticon-file"></i></span>
                                      </div>
                                            <input type="text" class="form-control" v-model="data.form.teacher_name" placeholder="المسئول" disabled="true">
                                            <div class="invalid-feedback" :style="getErrors['teacer_id'] ? 'display: block' : 'display: none;'"  v-if="getErrors['teacer_id']">
                                                  {{ getErrors['teacer_id'][0] }}
                                            </div>
                                        </div>
                                      </div>

                                      <div class="col-md-2">
                                        <div class="form-group mb-4">
                                            <label for="exampleFormControlInput12"> نوع السند</label><br>
                                            <input type="radio" v-model="data.form.type" value="cash">قبض
                                            <div class="invalid-feedback" :style="getErrors['type'] ? 'display: block' : 'display: none;'"  v-if="getErrors['type']">
                                                  {{ getErrors['type'][0] }}
                                            </div>
                                        </div>
                                      </div>


                                       <div class="col-md-4">
                                        <label for="exampleFormControlInput12"> رصيد الخزنة</label>
  <div class="input-group mb-4">
                                      
                                      <div class="input-group-prepend">
                                        <span class="input-group-text" id="basic-addon1"><i class="flaticon-money"></i></span>
                                      </div>
                                            <input type="text" class="form-control" v-model="cash" placeholder="رصيد الخزنة" disabled="true">
                                            
                                        </div>
                                      </div>
                                     

                                  
                                    </div>
                                    <button type="submit" class="save-btn btn-creative btn-3 btn-3a flaticon-cart-fill" fdprocessedid="6b18p"><span>حفظ</span></button>
                                    <button type="button" @click.prevent="resetForm" class="rewrite-btn btn-creative btn-3 btn-3a flaticon-cart-fill" fdprocessedid="6b18p"><span>تفريغ</span></button>
                                    <router-link class="back-btn btn-creative btn-3 btn-3a flaticon-cart-fill" fdprocessedid="6b18p" :to="{name: 'vouchers'}">
                                      <span>رجوع</span>
                                    </router-link>
                                </form>
                               
                            </div>
                        </div>
                    </div>

                </div>

            </div>
</template>
<script>
import router from '@/router'
import VueDatetimeJs from 'vue-datetime-js'
import 'vue-select/dist/vue-select.css';

import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
export default {
  components: {
    Treeselect,
    datePicker: VueDatetimeJs,

  },
  data() {
    return {
      current_cost: 0,
      cash: 0,
      isSync: false,
      teacher: '',
      items: [],
      teachers: [],
      stages: [],
      activities: [],
      students: [],
      stage: '',
      data: {
        checker: false,
         form:{
            created_date: '',
            teacher_id: '',
            budget_id: '',
            activity_id: '',
            stages: [],
            place: '',
            description: '',
            period: '',
            total_cost: '',
            teacher_name: '',
            type: 'cash',
            item_id: '',
            is_fees: 0,
            student_id: '',

        },
        roles: {
        },
        options: [],
        isRequested: false,
        errors: {},
        paginated: {}
      }
    };
  },
  created(){
      setTimeout(() => {
        this.isSync = true;
      }, 10000);
      this.getRequirements();
  },
  methods: {
    loadStOptions(){
      this.$baseApi.get('/vouchers/' + this.$route.params.id + '/edit?students=1', {
                    params: {stages: this.data.form.stages}
                }).then((response)=>{
            if(response.data.code == 200){
              this.students = response.data.data.students;

            }else{
                alert(response.data.error.error);
            }
        });
    },
    getStageCount(selectedValue) {
      var vm = this;
      this.$baseApi.get('/vouchers/' + this.$route.params.id + '/edit?fees=1&stage='+ selectedValue).then((response)=>{
            if(response.data.code == 200){
              if(selectedValue == vm.data.form.stage_id){
              vm.data.form.total_cost = vm.current_cost;  
              }else{
              vm.data.form.total_cost = response.data.data.fees;
              }
              vm.loadStOptions();

            }else{
                alert(response.data.error.error);
            }
        });
    },
    loadOptions({ action, searchQuery, callback }) {
         
        this.$baseApi.get('/vouchers/' + this.$route.params.id + '/edit?students=1&s='+ searchQuery, {
                    params: {stages: this.data.form.stages}
                }).then((response)=>{
            if(response.data.code == 200){
              callback(null, response.data.data.students)

            }else{
                alert(response.data.error.error);
            }
        });
    },
    formFeesChange(){
     
    },
    resetForm(){
      let dd = this.data.form.created_date;
      this.data.form =  {
            created_date: dd,
            teacher_id: '',
            budget_id: '',
            activity_id: '',
            stages: [],
            place: '',
            description: '',
            period: '',
            total_cost: '',
            teacher: '',
            type: 'cash',
            item_id: '',
            is_fees: 0,
            student_id: ''
        }
    },
      getInfo(){
        this.$baseApi.get('/vouchers/' + this.$route.params.id + '/edit').then((response)=>{
            if(response.data.code == 200 && response.data.data != null){
              let voucher = response.data.data.voucher;
              if(voucher.type != 'cash' || !voucher.is_fees){
                router.push('/student-fees-all');
              }
                this.data.form = voucher;
                this.current_cost = voucher.total_cost;
                // this.stages = response.data.data.stages;
                this.data.form.stages = this.data.form.all_stages;
                this.cash = response.data.data.cash;
                let arr = [];
               let dd  = response.data.data.activities;
               Object.keys(dd).forEach(key => {
                arr.push({id: dd[key], label: dd[key]});

              });
               
               this.activities = arr;
                // this.getDataOfSelect();

            }else if(response.data.code == 404){
                router.push('/student-fees-all');
            }else{
                alert(response.data.data.error);
                router.push('/student-fees-all');
            }
        });
      },
      update(){
          this.data.isRequested = true;
        this.$baseApi.patch('/vouchers/' + this.$route.params.id, this.data.form).then((response)=>{
            if(response.data.code === 200){
          localStorage.setItem('flash_message', 'تمت عملية العديل');

                router.push('/student-fees-all');
            }
        }).catch((error) => {
          this.data.errors = JSON.parse(JSON.stringify(error.response.data.errors));
          this.data.isRequested = false
        })
      },
      getRequirements(){
        this.getDataOfSelect();
        this.getInfo();
      },
      getDataFromStage(val){
        this.students = [];
        this.$baseApi.get('/vouchers/' + this.$route.params.id + '/edit?count=1&stage=' + val.id).then((response)=>{
            if(response.data.code == 200){
                 this.activities = response.data.data.activities;
               this.activity = '';
               this.data.form.activity_id = '';
               this.data.form.budget_id = '';
            }
        });
      },
      getHandleDataFrom(node){
        this.$baseApi.get('/vouchers/' + this.$route.params.id + '/edit?type=activity&activity=' + node.id).then((response)=>{
            if(response.data.code == 200){
              let activity = response.data.data.activity;
               this.data.form.place = activity.budget.place;
               this.data.form.period = activity.budget.period;
               this.data.form.description = activity.budget.description;
               this.data.form.teacher_id = activity.teacher_id;
               this.data.form.budget_id = activity.budget_id;
               this.data.form.teacher = activity.teacher.name;
               this.data.form.total_cost = activity.total_cost;
               this.data.form.stages = activity.all_stages;
            }
        });
      },
      getDataOfSelect(){
        this.$baseApi.get('/vouchers/' + this.$route.params.id + '/edit?pluck=1').then((response)=>{
            if(response.data.code == 200){
               this.stages = response.data.data.stages;
               console.log(this.stages)
               this.items = response.data.data.items;
               this.students = response.data.data.students;
               let arr = [];
               let dd  = response.data.data.activities;
               Object.keys(dd).forEach(key => {
                arr.push({id: dd[key], label: dd[key]});

              });
               
               this.activities = arr;
            }
        });
      },
  },
  computed: {
    trans(){
      return this.$store.getters.GET_TRANS;
    },
    user(){
      return this.$store.getters.SET_AUTH_USER;
    },
    getErrors() {
      return JSON.parse(JSON.stringify(this.data.errors))
    }
  },
  watch: {
   
  }
};
</script>
<style>
</style>
